import { Injectable, Inject, NgZone } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class AuthGuardService {

  constructor(@Inject(DOCUMENT) private document: HTMLDocument,
    private authentication: AuthenticationService,
    private zone: NgZone,
    private router: Router) { }

  canActivate(): boolean | Promise<boolean> {
    const isAuthenticated = this.authentication.isAuthenticated();
    const isAuthPage = window.location.pathname.includes('auth');
    const isCEAuthPage = window.location.pathname.includes('ce-authenticate');
    const isPairPage = window.location.pathname.includes('testgroup-pair');
    if (isPairPage || isCEAuthPage) {
      return true;
    }
    if (isAuthenticated) {
      if (isAuthPage) {
        this.router.navigate(['actions']);
      } else {
        return true;
      }
    } else {
      if (isAuthPage) {
        return true;
      } else {
        this.redirectToLoginPage(); return false;
      }
    }
  }

  redirectToLoginPage() {
    window.location.pathname = '/auth';
  }

}
